import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// import { HttpHeaders } from '@azure/core-http';
import { HttpHeaders } from '@angular/common/http';

let headers = new HttpHeaders()
headers=headers.set('Access-Control-Allow-Origin', '*');

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  
  constructor(private http: HttpClient ) { }

  postProduct(formData) {

    return this.http.post(environment.apiBaseURI + '/Product', formData,{ 'headers': headers })
  }

  putProduct(formData){
    return this.http.put(environment.apiBaseURI + '/Product/'+formData.Id, formData);
  }

  getProductList(){
    return this.http.get(environment.apiBaseURI + '/Product/GetProductDetailsList',{'headers':headers});
  }

  getProducts(){
    return this.http.get(environment.apiBaseURI + '/Product' );
  }

  // getProductsWithNomenclature(nomenclature){
  //   return this.http.get(environment.apiBaseURI + '/Product/' + nomenclature);
  // }

  deleteProduct(id) {
    return this.http.delete(environment.apiBaseURI + '/Product/' + id);
  }

}
